import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISessionState } from "../interfaces/i-session-state";
import { appSession, appStorage } from "../../commons";
import { User } from "../../commons/models/user";

const initialState = {
  user: new User(),
  token: "",
  theme: "light",
  microsoftUser: undefined,
} as ISessionState;
const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    /**
     * Set user in the session
     * @param state
     * @param action
     */
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload as User;
      appSession.setUser(action.payload);
    },
    /**
     * Update user in the session
     * @param state
     * @param action
     */
    updateUser(state, action: PayloadAction<User>) {
      if(state.user?.id === action.payload?.id) {
        const newUser = {...state.user, ...action.payload};
        state.user = newUser;
        appSession.setUser(new User().create(newUser) as User);
      }
    },
    /**
     * Remove user from session. Used for logout
     * @param state
     */
    removeUser(state) {
      state.user = undefined;
      appSession.removeUser();
    },
    /**
     * Set theme of the app
     */
    setTheme(state, action: PayloadAction<"dark" | "light">) {
      state.theme = action.payload;
      appStorage.setItem("appTheme", action.payload);
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload as string;
      appSession.setAccessToken(state.token);
    },
    // MIcrosoft user
    setMicrosoftUser(state, action) {
      state.microsoftUser = action.payload;
      appStorage.setItem("microsoftUser", action.payload);
    },
  },
});

export const { setUser,updateUser, removeUser, setTheme, setToken, setMicrosoftUser } = sessionSlice.actions;
export default sessionSlice.reducer;
